<div class="codes-container d-flex flex-wrap">
  <div class="w-25" *ngFor="let code of codes">{{ code }}</div>
</div>
<div class="d-flex my-15 justify-content-center align-items-center gap-15">
  <a class="cp" (click)="onClickCopy()"><i class="icon-copy"></i> Copy</a>
  <a class="cp" (click)="onClickDownload()"><i class="icon-export"></i> Download as txt file</a>
</div>
